var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-form-x',{attrs:{"title":"OO_LANG_PASS_EDIT","form":_vm.form},on:{"submit":_vm.sendForm}})}
var staticRenderFns = []

export { render, staticRenderFns }